// extracted by mini-css-extract-plugin
export default {"icon":"JoSmb_1L","wrapper":"g1dR0sNR","submit":"r7DfAY_0","button":"t4abD6lv","label":"cAP7WzPA"};